import apiParametrizacao from '@/app-modulo/comercial/Parametrizacao/ParametrizacaoGeral/services/api'

export default [
  {
    path: '/auditoria',
    name: 'auditoria',
    beforeEnter: async (to, from, next) => {
      try {
        const { data } = await apiParametrizacao.getAuditoriaStatus()
        if (data && data.habilitada === false) {
          return next({ name: 'dashboard-comercial' })
        }
      } catch {
        // mantém rota acessível se o status não puder ser consultado
      }
      return next()
    },
    component: () => import('@/app-modulo/comuns/auditoria/Lista/Auditorias.vue'),
    meta: {
      resource: 'parametrizacaogeral',
      action: 'read',
      requerAuditoriaHabilitada: true,
      pageTitle: 'Auditoria',
      breadcrumb: [
        {
          text: 'Organização',
        },
        {
          text: 'Auditoria',
          active: true,
        },
      ],
    },
  },
]
